/* global debounce */
$( ( $ ) => {
  const isMobile = () => {
    return window.matchMedia( '(min-width: 992px)' ).matches;
  };
  const addFullWidthClass = () => {
    $( '.bs-slider--solutions-see-everyone-slider .slick-slide-wrapper' ).each( function () {
      const className = $( this ).children( ':first' ).attr( 'class' ).split( ' ' )
        .find( cls => cls.startsWith( 'bs-div--slide-parent-' ) );
      $( this ).addClass( className );
    } );
  };
  const init = () => {
    if ( isMobile() ) {
      addFullWidthClass();
    }
  };
  init();
  $( window ).on( 'orientationchange', debounce( init, 100 ) );
} );

